<app-investment-asset-list [type]="2"></app-investment-asset-list>
